import { Route, Routes, useLocation } from 'react-router-dom';
import PageNotFoundView from './PageNotFoundView';
import { useCallback, useEffect } from 'react';
import trackPathForAnalytics from './GAAnalytics';
// import ToolMain from './Pages/WebTool/ToolMain';
import RichardQuiz from './Pages/RichardQuiz/RichardQuiz';
import MainFinancial from './Pages/Financial/MainFinancial';
import ChildrenBook from './Pages/ChildrenBook';
import BenTheTurtleStory from './Pages/BenTheTurtleStory';
import Main from './Pages/Website';
import ScrollToTop from './Components/ScrollToTop';
import RecipeBook from './Pages/RecipeBook/RecipeBook';
import Resume from './Pages/Resume';
import SantasAILab from './Pages/SantasAILab/SantasAILab';
import ExperiencePage from './Pages/Experience/ExperiencePage';
// Portfolio is hidden for now; the page lives in src/Pages/Portfolio.jsx.
// import Portfolio from './Pages/Portfolio';

function App() {

  const { pathname, search } = useLocation();

  const analytics = useCallback(() => {
    trackPathForAnalytics({ path: pathname, search: search, title: pathname.split("/")[1] });
  }, [pathname, search]);

  useEffect(() => {
    analytics();
  }, [analytics]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/santas-ai-lab" element={<SantasAILab />} />
        <Route path="/experience/feels" element={<ExperiencePage experienceKey="feels" />} />
        <Route path="/experience/snap" element={<ExperiencePage experienceKey="snap" />} />
        <Route path="/experience/story-star" element={<ExperiencePage experienceKey="story-star" />} />
        <Route path="/experience/rbc-wealth-management" element={<ExperiencePage experienceKey="rbc-wealth-management" />} />
        <Route path="/experience/kinetic-commerce" element={<ExperiencePage experienceKey="kinetic-commerce" />} />
        <Route path="/experience/turbo-rocket-games" element={<ExperiencePage experienceKey="turbo-rocket-games" />} />
        <Route path="/experience/eventlime" element={<ExperiencePage experienceKey="eventlime" />} />
        <Route path="/experience/brock-university" element={<ExperiencePage experienceKey="brock-university" />} />
        <Route path="/experience/agency-sm-art" element={<ExperiencePage experienceKey="agency-sm-art" />} />
        {/* <Route path="/portfolio" element={<Portfolio />} /> */}
        <Route path="/no-page-found" element={<PageNotFoundView />} />

        {/* <Route path="/writter-tool" element={<ToolMain />} /> */}
        <Route path="/richard-quiz" element={<RichardQuiz />} />
        <Route path="/financial" element={<MainFinancial />} />
        <Route path="/children-book" element={<ChildrenBook />} />
        <Route path="/ben-the-turtle-story" element={<BenTheTurtleStory />} />
        <Route path="/recipe-book/*" element={<RecipeBook />} />

      </Routes>
    </>
  );
}

export default App;
